import { render, staticRenderFns } from "./GanteviewItem.vue?vue&type=template&id=8196d050&"
import script from "./GanteviewItem.vue?vue&type=script&lang=js&"
export * from "./GanteviewItem.vue?vue&type=script&lang=js&"
import style0 from "./GanteviewItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GanteviewItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports